/**
 * this file is deprecated, please use color-token.ts
 */
import { borderColor, palette, textColor } from './color-token';
/**
 * @deprecated use palette
 */

export const HUES = {
  /**
   * @deprecated use palette
   */
  RED: palette['palette-red'],

  /**
   * @deprecated use RED_DARK_300 instead
   */
  RED_DARK: '#BA1309',

  /**
   * @deprecated use palette
   */
  RED_DARK_100: '#CC1800',

  /**
   * @deprecated use palette
   */
  RED_DARK_300: '#BA1309',

  /**
   * @deprecated use palette
   */
  RED_LIGHT_300: '#FDEDEB',

  /**
   * @deprecated use palette
   */
  RED_LIGHT_400: '#FBDAD6',

  /**
   * @deprecated use palette
   */
  BLUE: '#1173BC',

  /**
   * @deprecated use palette
   */
  BLUE_DARK: '#1B409E',

  /**
   * @deprecated use palette
   */
  BLUE_DARK_100: '#4F72A6',

  /**
   * @deprecated use palette
   */
  BLUE_LIGHT: '#ECF6FD',

  /**
   * @deprecated use palette
   */
  GREEN: '#27A86C',

  /**
   * @deprecated use palette
   */
  GREEN_DARK: '#036D38',

  /**
   * @deprecated use palette
   */
  TEAL: '#00A38F',

  /**
   * @deprecated use palette
   */
  TEAL_LIGHT: '#C3CBE3',

  /**
   * @deprecated use palette
   */
  TEAL_DARK: '#035151',

  /**
   * @deprecated use palette
   */
  VIOLET: '#93278F',

  /**
   * @deprecated use palette
   */
  VIOLET_DARK: '#661C66',

  /**
   * @deprecated use palette
   */
  VIOLET_LIGHT: '#7E5DAE',

  /**
   * @deprecated use palette
   */
  GOLD: '#FFAA00',

  /**
   * @deprecated use palette
   */
  GOLD_LIGHT: '#FBE5b8',

  /**
   * @deprecated use palette
   */
  ORANGE: '#EC5A13',

  /**
   * @deprecated use palette
   */
  ORANGE_DARK_300: '#712C08',

  /**
   * @deprecated use palette
   */
  NAVY: '#1E2851',

  /**
   * @deprecated use palette
   */
  NAVY_LIGHT: '#3F486A'
};
/**
 * @deprecated use palette
 */

export const NEUTRALS = {
  /**
   * @deprecated use palette
   */
  TRANSPARENT: 'transparent',

  /**
   * @deprecated use palette
   */
  BLACK: '#000',

  /**
   * @deprecated use palette
   */
  GREY_COOL_DARK_400: '#242528',

  /**
   * @deprecated use palette
   */
  GREY_COOL_DARK_300: '#4D4C4E',

  /**
   * @deprecated use palette
   */
  GREY_COOL_DARK_200: '#737478',

  /**
   * @deprecated use palette
   */
  GREY_COOL_DARK_100: '#95969B',

  /**
   * @deprecated use palette
   */
  GREY_COOL: '#AEB1B5',

  /**
   * @deprecated use palette
   */
  GREY_COOL_LIGHT_100: '#CACBD1',

  /**
   * @deprecated use palette
   */
  GREY_COOL_LIGHT_200: '#E3E5E9',

  /**
   * @deprecated use palette
   */
  GREY_COOL_LIGHT_300: '#F1F1F5',

  /**
   * @deprecated use palette
   */
  GREY_COOL_LIGHT_400: '#F5F6FA',

  /**
   * @deprecated use palette
   */
  WHITE: '#FFF'
};
/**
 * @deprecated use color token
 */

export const BRAND_COLORS = {
  PRIMARY: HUES.RED,
  PRIMARY_HOVER: HUES.RED_DARK_100,
  PRIMARY_NAVY: HUES.NAVY,
  PRIMARY_NAVY_HOVER: HUES.NAVY_LIGHT
}; // //QUESTION: is there a nice syntax that lets us define some of these in terms of ones we've previously defined?  E.g. FIELD: value, FIELD_READONLY: FIELD etc.

/**
 * @deprecated use color token
 */

export const FUNCTIONAL_COLORS = {
  /**
   * @deprecated use color token
   */
  HEADINGS: NEUTRALS.GREY_COOL_DARK_400,

  /**
   * @deprecated use color token
   */
  BODY_COPY: NEUTRALS.GREY_COOL_DARK_300,

  /**
   * @deprecated use color token
   */
  FOOTNOTE: NEUTRALS.GREY_COOL_DARK_100,

  /**
   * @deprecated use color token
   */
  HINT_GREY: NEUTRALS.GREY_COOL,

  /**
   * @deprecated unused
   */
  PLACEHOLDER: NEUTRALS.GREY_COOL,

  /**
   * @deprecated use color token
   */
  SURFACE_BORDER: NEUTRALS.GREY_COOL_LIGHT_200,
  FIELD: NEUTRALS.GREY_COOL_DARK_300,

  /**
   * @deprecated use color token
   */
  FIELD_BACKGROUND: NEUTRALS.WHITE,

  /**
   * @deprecated use color token
   */
  FIELD_BORDER: NEUTRALS.GREY_COOL,

  /**
   * @deprecated use color token
   */
  BORDER_HOVER: NEUTRALS.GREY_COOL_DARK_100,

  /**
   * @deprecated use color token
   */
  BORDER_FOCUS: NEUTRALS.GREY_COOL_DARK_400,

  /**
   * @deprecated unused
   */
  BORDER_FOCUS_HOVER: NEUTRALS.GREY_COOL_DARK_400,

  /**
   * @deprecated use color token
   */
  FIELD_PLACEHOLDER: NEUTRALS.GREY_COOL_DARK_100,

  /**
   * @deprecated use color token
   */
  BORDER_PLACEHOLDER: NEUTRALS.GREY_COOL,

  /**
   * @deprecated use color token
   */
  FIELD_ERROR: NEUTRALS.GREY_COOL_DARK_300,

  /**
   * @deprecated use color token
   */
  FIELD_ERROR_BACKGROUND: NEUTRALS.WHITE,

  /**
   * @deprecated use color token
   */
  BORDER_ERROR: borderColor['color-border-error'],

  /**
   * @deprecated use color token
   */
  BORDER_ERROR_HOVER: '#730E00',

  /**
   * @deprecated use color token
   */
  BORDER_ERROR_FOCUS: '#730E00',

  /**
   * @deprecated unused
   */
  // BORDER_ERROR_FOCUS_HOVER: HUES.RED_DARK_300,

  /**
   * @deprecated use color token
   */
  FIELD_DISABLED: NEUTRALS.GREY_COOL_DARK_100,

  /**
   * @deprecated use color token
   */
  FIELD_DISABLED_BACKGROUND: NEUTRALS.GREY_COOL_LIGHT_300,

  /**
   * @deprecated use color token
   */
  BORDER_DISABLED: NEUTRALS.GREY_COOL_LIGHT_200,

  /**
   * @deprecated use color token
   */
  BORDER_DISABLED_HOVER: NEUTRALS.GREY_COOL_LIGHT_200,

  /**
   * @deprecated use color token
   */
  BORDER_DISABLED_FOCUS: NEUTRALS.GREY_COOL_LIGHT_200,

  /**
   * @deprecated unused
   */
  BORDER_DISABLED_FOCUS_HOVER: NEUTRALS.GREY_COOL_LIGHT_200,

  /**
   * @deprecated use color token
   */
  FIELD_READONLY: NEUTRALS.GREY_COOL_DARK_300,

  /**
   * @deprecated use color token
   */
  FIELD_READONLY_BACKGROUND: NEUTRALS.GREY_COOL_LIGHT_300,

  /**
   * @deprecated use color token
   */
  BORDER_READONLY: NEUTRALS.GREY_COOL_LIGHT_200,

  /**
   * @deprecated use color token
   */
  BORDER_READONLY_HOVER: NEUTRALS.GREY_COOL_LIGHT_200,

  /**
   * @deprecated use color token
   */
  BORDER_READONLY_FOCUS: NEUTRALS.GREY_COOL_LIGHT_200,

  /**
   * @deprecated unused
   */
  BORDER_READONLY_FOCUS_HOVER: NEUTRALS.GREY_COOL_LIGHT_200,

  /**
   * @deprecated use color token
   */
  FIELD_CHECKBOX_CHECKED: NEUTRALS.WHITE,

  /**
   * @deprecated use color token
   */
  FIELD_CHECKBOX_CHECKED_BACKGROUND: NEUTRALS.GREY_COOL_DARK_200,

  /**
   * @deprecated use color token
   */
  FIELD_RADIO_CHECKED_BACKGROUND: NEUTRALS.GREY_COOL_LIGHT_300,

  /**
   * @deprecated use color token
   */
  FIELD_CHECKBOX_CHECKED_DISABLED: NEUTRALS.GREY_COOL_LIGHT_100,

  /**
   * @deprecated use color token
   */
  TYPE_ICON: NEUTRALS.GREY_COOL_DARK_300,

  /**
   * @deprecated use color token
   */
  ERROR_ICON: textColor['color-text-error'],

  /**
   * @deprecated use color token
   */
  ERROR_MESSAGE: textColor['color-text-error'],

  /**
   * @deprecated use color token
   */
  INNER_BACKGROUND: NEUTRALS.GREY_COOL_LIGHT_300,

  /**
   * @deprecated use color token
   */
  PAGE_BACKGROUND: NEUTRALS.GREY_COOL_LIGHT_400,

  /**
   * @deprecated use color token
   */
  REQUIRED_MARKER: HUES.RED,

  /**
   * @deprecated use color token
   */
  REQUIRED_TEXT: NEUTRALS.GREY_COOL_DARK_300,

  /**
   * @deprecated use color token
   */
  BAR_CHART_PRIMARY: palette['palette-blue-dark-300'],

  /**
   * @deprecated use color token
   */
  BAR_CHART_SECONDARY: palette['palette-gold'],
  CALENDAR_TEXT: NEUTRALS.GREY_COOL_DARK_300,
  CALENDAR_DISABLED_TEXT: NEUTRALS.GREY_COOL,
  CALENDAR_DATE_SELECTED: HUES.BLUE_DARK,
  CALENDAR_DATE_IN_RANGE: HUES.TEAL_LIGHT,
  CALENDAR_ACTIVE_HOVER: HUES.BLUE_DARK,
  CALENDAR_ACTIVE_TEXT: NEUTRALS.WHITE,
  CALENDAR_RESERVED_DATE_SELECTED: HUES.GOLD,
  CALENDAR_RESERVED_DATE_IN_RANGE: HUES.GOLD_LIGHT,
  CALENDAR_RESERVED_TEXT: NEUTRALS.WHITE
};
export const COLORS_BASIC = { ...HUES,
  ...NEUTRALS
};